export default {"src":"/_next/static/media/avatar.6b5d5fd0.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};